import {Link} from "react-router-dom";
import {Aux, BASE_URL, IsNullOrUndefined} from "../../constants";
import React from "react";
import AutoFocusTextInput from "../Common/AutoFocusTextInput";

const TankRequestInput = (props) => {
    let {pickup, run, isEditMode, onAssignTank, isAdmin} = props;
    let tankRequests = pickup.tankRequests;

    if(!run.isBaseCheckedIn || (run.isComplete && !isAdmin) ){
        return null;
    } else {
        return (tankRequests.filter(x => IsNullOrUndefined(x.actionCompleteDate)).map(tankRequest => {
            return (
                <div key={tankRequest.id} className={"mb-2 mt-2"}>
                    <div className="row">
                        <div className="col-12">
                            <h4 className={`text-${tankRequest.tankId > 0 ? 'success': 'danger'}`}>
                                <i
                                    className={"fa fa-plus-square text-danger mr-1"}
                                    data-toggle="tooltip" data-placement="top" title="Assign tank"
                                />{ isEditMode ? <a href={''} onClick={e => onAssignTank(e, tankRequest, pickup)}>Assign {tankRequest.tankName}</a>
                                : <span>{tankRequest.tankName}</span>}
                            </h4>
                        </div>
                    </div>
                </div>
            );
        }));
    }
};

export default TankRequestInput;